// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Spinner = require("../../../uikit/reason/atoms/Spinner/Spinner.bs.js");
var Tooltip = require("../../common/Tooltip.bs.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Icon__Jsx3 = require("../../../uikit/reason/atoms/Icon/Icon__Jsx3.bs.js");
var Text__Jsx3 = require("../../../uikit/reason/helpers/Text__Jsx3.bs.js");
var Attachments = require("../../common/Attachments/Attachments.bs.js");
var Theme__Color = require("../../common/Theme/Theme__Color.bs.js");
var TailwindMerge = require("tailwind-merge");
var JsxRuntime = require("react/jsx-runtime");
var Colors = require("uikit/styles/colors");
var AttachmentFormSection = require("../../../v5/common/attachments/AttachmentFormSection.bs.js");
var ReactAriaComponents = require("react-aria-components");
var VisuallyHidden = require("@reach/visually-hidden").default;

function ConversationInput__Attachments$ConversationAttachmentItem$Tooltip(props) {
  var uploadState = props.uploadState;
  var tmp;
  tmp = typeof uploadState !== "object" ? (
      uploadState === "Success" ? "Click to remove" : "Upload failed. Click to remove"
    ) : uploadState._0.toString() + "%";
  return JsxRuntime.jsx(Tooltip.make, {
              label: tmp,
              children: props.children
            });
}

var Tooltip$1 = {
  make: ConversationInput__Attachments$ConversationAttachmentItem$Tooltip
};

function ConversationInput__Attachments$ConversationAttachmentItem$RemoveButton(props) {
  var onPress = props.onPress;
  var uploadState = props.uploadState;
  var tmp;
  tmp = typeof uploadState !== "object" ? (
      uploadState === "Success" ? JsxRuntime.jsx(Icon__Jsx3.make, {
              icon: "Cancel",
              size: 10
            }) : JsxRuntime.jsx(Icon__Jsx3.make, {
              icon: "AttentionAlt",
              size: 12,
              color: Theme__Color.crimson
            })
    ) : JsxRuntime.jsx(Spinner.make, {
          size: 10,
          stroke: "black"
        });
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(ConversationInput__Attachments$ConversationAttachmentItem$Tooltip, {
                    uploadState: uploadState,
                    children: JsxRuntime.jsxs(ReactAriaComponents.Button, {
                          children: [
                            JsxRuntime.jsx(VisuallyHidden, {
                                  children: props.title
                                }),
                            JsxRuntime.jsx("span", {
                                  children: tmp,
                                  "aria-hidden": true,
                                  className: "pointer-events-none flex"
                                })
                          ],
                          className: (function (param) {
                              var tmp;
                              tmp = typeof uploadState !== "object" && uploadState !== "Success" ? "border-tan-error-500" : "border-zinc-400";
                              return TailwindMerge.twMerge([
                                          "bg-white border rounded-full cursor-pointer p-[5px] text-black hover:bg-zinc-100",
                                          tmp
                                        ]);
                            }),
                          onClick: (function (e) {
                              onPress(e);
                            }),
                          type: "button"
                        })
                  }),
              className: "absolute -top-2.5 -right-2.5"
            });
}

var RemoveButton = {
  make: ConversationInput__Attachments$ConversationAttachmentItem$RemoveButton
};

function ConversationInput__Attachments$ConversationAttachmentItem(props) {
  var onDeleteAttachment = props.onDeleteAttachment;
  var upload = props.upload;
  var match = upload.state;
  var uploadState;
  switch (match.TAG) {
    case "NotStarted" :
        uploadState = {
          TAG: "InProgress",
          _0: 0
        };
        break;
    case "InProgress" :
        uploadState = {
          TAG: "InProgress",
          _0: match._1 * 100
        };
        break;
    case "Failed" :
        uploadState = "Error";
        break;
    case "Success" :
        uploadState = "Success";
        break;
    
  }
  var content = Attachments.Attachment.isImage(upload) ? ({
        NAME: "Image",
        VAL: upload.previewUrl
      }) : ({
        NAME: "File",
        VAL: Attachments.Attachment.fileName(upload)
      });
  var tmp;
  if (content.NAME === "File") {
    var tmp$1;
    tmp$1 = typeof uploadState !== "object" ? "" : "opacity-60";
    tmp = JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx(Icon__Jsx3.make, {
                  icon: "File",
                  size: 20,
                  color: Theme__Color.mineShaft
                }),
            JsxRuntime.jsx(Text__Jsx3.make, {
                  fontWeight: "bold",
                  color: Colors.mineShaft,
                  children: content.VAL
                })
          ],
          className: TailwindMerge.twMerge([
                "flex flex-row items-center gap-1 bg-zinc-300 px-2.5 py-1.5 rounded",
                tmp$1
              ])
        });
  } else {
    var tmp$2;
    tmp$2 = typeof uploadState !== "object" ? "" : "opacity-60";
    tmp = JsxRuntime.jsx("img", {
          className: TailwindMerge.twMerge([
                "w-[50px] h-[50px] rounded-md object-cover",
                tmp$2
              ]),
          src: content.VAL
        });
  }
  return JsxRuntime.jsxs("div", {
              children: [
                tmp,
                JsxRuntime.jsx(ConversationInput__Attachments$ConversationAttachmentItem$RemoveButton, {
                      uploadState: uploadState,
                      onPress: (function (param) {
                          onDeleteAttachment(Attachments.Attachment.id(upload));
                        }),
                      title: "Remove " + Attachments.Attachment.fileName(upload)
                    })
              ],
              className: "relative"
            });
}

var ConversationAttachmentItem = {
  Tooltip: Tooltip$1,
  RemoveButton: RemoveButton,
  make: ConversationInput__Attachments$ConversationAttachmentItem
};

function ConversationInput__Attachments$AddButton(props) {
  return JsxRuntime.jsx(AttachmentFormSection.FileInputLink.make, {
              onChange: props.onAddAttachment,
              multiple: true,
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("span", {
                            children: "+",
                            "aria-hidden": true
                          }),
                      JsxRuntime.jsx(VisuallyHidden, {
                            children: "Attach images and files"
                          })
                    ],
                    className: "border border-zinc-300 rounded-full bg-white text-zinc-600 hover:border-tan-blue-500 hover:bg-tan-blue-500 hover:text-white transition-colors duration-150 w-8 h-8 cursor-pointer flex items-center justify-center pb-[5px] text-4xl font-light"
                  })
            });
}

var AddButton = {
  make: ConversationInput__Attachments$AddButton
};

function ConversationInput__Attachments(props) {
  var onDeleteAttachment = props.onDeleteAttachment;
  var match = Belt_Array.partition(props.uploads, Attachments.Attachment.isImage);
  return JsxRuntime.jsxs("div", {
              children: [
                match[0].map(function (upload) {
                      return JsxRuntime.jsx(ConversationInput__Attachments$ConversationAttachmentItem, {
                                  upload: upload,
                                  onDeleteAttachment: onDeleteAttachment
                                }, Attachments.Attachment.id(upload));
                    }),
                match[1].map(function (upload) {
                      return JsxRuntime.jsx(ConversationInput__Attachments$ConversationAttachmentItem, {
                                  upload: upload,
                                  onDeleteAttachment: onDeleteAttachment
                                }, Attachments.Attachment.id(upload));
                    })
              ],
              className: "flex flex-row flex-wrap gap-4 mb-4"
            });
}

var make = ConversationInput__Attachments;

exports.ConversationAttachmentItem = ConversationAttachmentItem;
exports.AddButton = AddButton;
exports.make = make;
/* Spinner Not a pure module */
